/* eslint-disable no-console */
export const logger = {
  error: (message: string, error?: unknown) => {
    if (process.env.NODE_ENV !== 'prod') {
      console.error(message, error);
    }
  },
  warn: (message: string) => {
    if (process.env.NODE_ENV !== 'prod') {
      console.warn(message);
    }
  },
  info: (message: string, data?: unknown) => {
    if (process.env.NODE_ENV !== 'prod') {
      console.info(message, data);
    }
  },
};
